import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import userService from '../../../services/userService'; // Adjust the import path as necessary
import ClientOptionLabel, {
  buildClientSearchText,
  getClientSelectedLabel,
} from '../../common/ClientOptionLabel';
const { Option } = Select;

const UserSelector = ({ 
  value, 
  onChange, 
  multiple = false, 
  roles = null,
  placeholder = "Select user(s)", 
  style = {},
  disabled = false,
  allowClear = true,
  showSearch = true
}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    fetchUsers();
    // fetchUsers is defined in-component; we only want this once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const params = { limit: 300, roles: roles };
      const response = await userService.getAllCustomers(params);
      
      if (response && response.data) {
        setUsers(response.data);
      }
    } catch (error) {
      console.error('Error fetching users in UserSelector:', error);
    } finally {
      setLoading(false);
    }
  };

  // Filter users based on search
  const filteredUsers = users.filter(user => {
    if (!searchValue) return true;
    
    const searchLower = searchValue.toLowerCase();
    return buildClientSearchText(user).includes(searchLower);
  });

  // Handle selection change
  const handleChange = (selectedValue) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  // Handle search input
  const handleSearch = (searchText) => {
    setSearchValue(searchText);
  };

  return (
    <Select
      style={style}
      value={value}
      onChange={handleChange}
      onSearch={showSearch ? handleSearch : undefined}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      showSearch={showSearch}
      mode={multiple ? 'multiple' : undefined}
      loading={loading}
      filterOption={false} // We handle filtering manually
      notFoundContent={loading ? <Spin size="small" /> : 'No users found'}
      optionLabelProp="label" // This ensures the label is shown in the selector
    >
      {filteredUsers.map(user => (
        <Option 
          key={user.id} 
          value={user.id}
          label={getClientSelectedLabel(user)} // This is what shows in the selected value
        >
          <div className="flex items-center">
            <UserOutlined className="mr-2" />
            <ClientOptionLabel client={user} />
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default UserSelector;